function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 12 14"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M9.75.25h-7.5c-.825 0-1.5.675-1.5 1.5v12L6 11.5l5.25 2.25v-12c0-.825-.675-1.5-1.5-1.5z",
  fill: "#fff"
})));